
















































import { Vue, Component } from "@/shared/vuepack";
import { BalanceTransferMethod } from "@/shared/types";
import Button from "@/shared/components/ui/Button.vue";
import { useBalanceTransferStore, goToStep } from "@/employee/store/balanceTransfer";

@Component({
  components: {
    Button
  }
})
export default class TransferFunds extends Vue {
  balanceTransferStore = useBalanceTransferStore();

  BalanceTransferMethod = BalanceTransferMethod;

  get nextDisabled () {
    return this.balanceTransferStore.transferMethod === BalanceTransferMethod.None;
  }

  updateSelection (transferMethod: BalanceTransferMethod) {
    this.balanceTransferStore.transferMethod = transferMethod;
  }

  isSelected (transferMethod: BalanceTransferMethod) {
    return this.balanceTransferStore.transferMethod === transferMethod;
  }

  onNext () {
    switch (this.balanceTransferStore.transferMethod) {
      case BalanceTransferMethod.TrusteeToTrustee:
        goToStep("trustee-details");
        break;
      case BalanceTransferMethod.Rollover:
        goToStep("rollover-details");
        break;
    }
  }
}
